<script setup lang="ts">
  import { computed, defineAsyncComponent } from 'vue'
  import { TravelDirection } from '@/shared/types/common.types'
  import { useFeaturesStore } from '@/shared/store/featuresStore'

  interface Emits {
    (e: 'back'): void
  }

  const emit = defineEmits<Emits>()

  const FlowQuoteWidget = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowQuoteWidget/FlowQuoteWidget.vue')
  )
  const FlowQuoteWidgetQC = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowQuoteWidgetQC/FlowQuoteWidgetQC.vue')
  )

  const featuresStore = useFeaturesStore()
  const isDsQuoteEnabled = computed(() => featuresStore.isDsQuoteEnabled)

  const onEditTravelers = () => {
    emit('back')
  }
</script>

<template>
  <FlowQuoteWidgetQC
    v-if="isDsQuoteEnabled"
    :type-of-travel="TravelDirection.INBOUND"
    @edit-travelers="onEditTravelers"
  />
  <FlowQuoteWidget
    v-else
    :type-of-travel="TravelDirection.INBOUND"
    @edit-travelers="onEditTravelers"
  />
</template>
